/**
 * Control whether retailers see the (in-product) notifications
 * https:www.notion.so/faire/In-product-notifications-v1-26d643ccd52b4da8ab6d32347de4be3d?pvs=4
 * Product Area: RETAILER_NOTIFICATIONS
 */
export const ENABLE_RETAILER_NOTIFICATION_240502 = 'ENABLE_RETAILER_NOTIFICATION_240502';
